import React, { useEffect, useRef } from 'react';
import { View, Text, Animated, StyleSheet, Platform } from 'react-native';

export const NotificationPopup = ({ message, type = 'success', duration = 3000, onHide }) => {
  const translateY = useRef(new Animated.Value(100)).current;
  const opacity = useRef(new Animated.Value(0)).current;
  const scale = useRef(new Animated.Value(0.9)).current;

  useEffect(() => {
    // Show animation
    Animated.parallel([
      Animated.spring(translateY, {
        toValue: 0,
        tension: 50,
        friction: 10,
        useNativeDriver: true,
      }),
      Animated.timing(opacity, {
        toValue: 1,
        duration: 200,
        useNativeDriver: true,
      }),
      Animated.spring(scale, {
        toValue: 1,
        tension: 50,
        friction: 10,
        useNativeDriver: true,
      }),
    ]).start();

    // Hide animation after duration
    const hideTimer = setTimeout(() => {
      Animated.parallel([
        Animated.spring(translateY, {
          toValue: 100,
          tension: 50,
          friction: 10,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
        }),
        Animated.spring(scale, {
          toValue: 0.9,
          tension: 50,
          friction: 10,
          useNativeDriver: true,
        }),
      ]).start(() => {
        if (onHide) onHide();
      });
    }, duration);

    return () => clearTimeout(hideTimer);
  }, [message]);

  const getIcon = () => {
    return type === 'success' ? '✓' : '✕';
  };

  const getColors = () => {
    return type === 'success' 
      ? { bg: '#10B981', icon: '#34D399' }  // Modern green shades
      : { bg: '#EF4444', icon: '#F87171' };  // Modern red shades
  };

  const colors = getColors();

  return (
    <Animated.View
      style={[
        styles.container,
        {
          transform: [
            { translateY },
            { scale }
          ],
          opacity,
          backgroundColor: colors.bg,
        },
      ]}
    >
      <View style={[styles.iconContainer, { backgroundColor: colors.icon }]}>
        <Text style={styles.icon}>{getIcon()}</Text>
      </View>
      <Text style={styles.message}>{message}</Text>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 40,
    left: '50%',
    transform: [{ translateX: '-50%' }],
    width: 400,
    maxWidth: '90%',
    padding: 16,
    borderRadius: 12,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 5,
    zIndex: 1000,
    ...(Platform.OS === 'web' && {
      backdropFilter: 'blur(8px)',
    }),
  },
  iconContainer: {
    width: 28,
    height: 28,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  icon: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
  },
  message: {
    flex: 1,
    color: 'white',
    fontSize: 16,
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    lineHeight: 20,
  },
}); 